import Navbar from "../../../components/Navbar/Navbar";
import General from "../components/General/General";

export default function UserPreferences() {
    return (
        <>
            <Navbar title="Preferences" />
            <div className="page">
                <div className="max-w-[680px] mx-auto">
                    <General />
                </div>
            </div>
        </>
    );
}
